import { apiClient } from "api";
import { AxiosProgressEvent } from "axios";
import config from "../../account-config.json";
import { TUploadJobFile } from "./models/types";

export const uploadFile = (uploadFile: TUploadJobFile): Promise<TUploadJobFile> => {
  const formData = new FormData();
  const isMrrAccount =
    !!uploadFile.accountId && config["pdfDisabled"].includes(uploadFile.accountId);
  formData.append("file", uploadFile.file, uploadFile.name);
  formData.append("accountId", uploadFile.accountId!);
  formData.append("providerId", String(uploadFile.providerId!));
  formData.append("locationId", String(uploadFile.locationId!));
  formData.append("isVoiceFile", String(uploadFile.isVoiceFile));
  formData.append("isMrrAccount", String(isMrrAccount));

  return apiClient
    .post("UploadJob", formData, {
      headers: {
        "Content-Type": "multipart/form-data"
      },
      timeout: 1200000, // 20 minutes
      onUploadProgress: (progressEvent: AxiosProgressEvent) => {
        const progress = Math.round((progressEvent.loaded * 100) / (progressEvent.total ?? 1));
        // Update your progress bar or display the progress percentage here
        console.log(`Upload Progress: ${progress}%`);
      }
    })
    .then(r => uploadFile);
};
